'use client';
import { useTheme } from "next-themes";
import Image, { ImageProps } from "next/image";
import { memo } from 'react';

type Props = Omit<ImageProps, 'src'> & { src: string; darkSrc?: string; fallbackSrc?: string; className?: string; eager?: boolean; };

const ThemedImage = ({ src, darkSrc = src, fallbackSrc, className, eager, ...rest }: Props) => {
  const { theme } = useTheme();

  return (
    <Image quality={100} {...rest} alt={rest.alt || ''} src={theme === 'dark' ? darkSrc : src} priority={eager ? true : undefined} loading={eager ? 'eager' : 'lazy'} fetchPriority={eager ? 'high' : 'low'} />
  )
}

export default memo(ThemedImage);